import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { SimpleTableCard } from "@/partner/shared/components/SimpleTableCard";
import { formatNumber } from "@/shared/utils/formatNumber";
import { useAnalyticsViewsByDeviceOsQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsViewsByDeviceOsTable: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  const { data, loading, error } = useAnalyticsViewsByDeviceOsQuery({
    variables: { filter: filter as never },
  });

  const rows = (data?.analyticsViews.viewsByDeviceOs ?? []).map((row) => [
    row.label,
    formatNumber(row.views),
  ]);

  return (
    <SimpleTableCard
      title={t("analytics.views.tableByDeviceOs")}
      columns={[
        { name: t("analytics.views.columnDeviceOs") },
        { name: t("analytics.views.columnViews") },
      ]}
      rows={rows}
      loading={loading}
      error={error}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.ViewsByDeviceOsType}
          filter={filter}
        />
      }
    />
  );
};
